import { render, staticRenderFns } from "./MakinaFotos.vue?vue&type=template&id=09ab5807&scoped=true&"
import script from "./MakinaFotos.vue?vue&type=script&lang=js&"
export * from "./MakinaFotos.vue?vue&type=script&lang=js&"
import style0 from "./MakinaFotos.vue?vue&type=style&index=0&id=09ab5807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab5807",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VCarousel,VCarouselItem,VImg})
